import { create } from 'zustand'
import { produce } from 'immer'
import { loadAgendaTemplate } from '../../services/templates/agendaInteligente'

const defaultData = {
  isLoading: false,
  error: null,
  agendamentos: { hoje: [], amanha: [], depoisDeAmanha: [] },
  resumo: {
    hoje: { total: 0, assinantes: 0, novosClientes: 0, confirmados: 0 },
    amanha: { total: 0, assinantes: 0, novosClientes: 0, confirmados: 0 },
    depoisDeAmanha: { total: 0, assinantes: 0, novosClientes: 0, confirmados: 0 },
  },
  datas: { hoje: '', amanha: '', depoisDeAmanha: '' },
  activeTab: 'hoje',
  filter: { status: 'todos', type: 'todos', query: '' },
  contactStatus: {},
  contactDone: {},
  historyCache: {},
  expandedId: null,
  waApptId: null,
  settingsOpen: false,
  template: '',
}

export const useAgendaInteligente = create(set => ({
  data: { ...defaultData, template: loadAgendaTemplate() },
  actions: {
    setLoading: (isLoading) =>
      set(state => produce(state, d => { d.data.isLoading = isLoading })),

    setError: (error) =>
      set(state => produce(state, d => { d.data.error = error })),

    setAgenda: ({ agendamentos, resumo, datas }) =>
      set(state => produce(state, d => {
        const contactDone = Object.values(agendamentos)
          .flat()
          .reduce((result, appointment) => {
            result[appointment.appointmentId] = Boolean(appointment.contacted)
            return result
          }, {})

        d.data.agendamentos = agendamentos
        d.data.resumo = resumo
        d.data.datas = datas
        d.data.contactDone = contactDone
        d.data.error = null
      })),

    setActiveTab: (activeTab) =>
      set(state => produce(state, d => { d.data.activeTab = activeTab })),

    setFilter: (filter) =>
      set(state => produce(state, d => {
        d.data.filter = { ...state.data.filter, ...filter }
      })),

    setContactStatus: (appointmentId, status) =>
      set(state => produce(state, d => {
        d.data.contactStatus[appointmentId] = status
        Object.values(d.data.agendamentos).flat().forEach(appointment => {
          if (appointment.appointmentId === appointmentId) {
            appointment.status = status
          }
        })
      })),

    setContactDone: (appointmentId, done) =>
      set(state => produce(state, d => {
        d.data.contactDone[appointmentId] = done
        Object.values(d.data.agendamentos).flat().forEach(appointment => {
          if (appointment.appointmentId === appointmentId) {
            appointment.contacted = done
          }
        })
      })),

    setContactDoneMany: (appointmentIds, done) =>
      set(state => produce(state, d => {
        const appointmentIdSet = new Set(appointmentIds)

        appointmentIds.forEach(appointmentId => {
          d.data.contactDone[appointmentId] = done
        })

        Object.values(d.data.agendamentos).flat().forEach(appointment => {
          if (appointmentIdSet.has(appointment.appointmentId)) {
            appointment.contacted = done
          }
        })
      })),

    setHistoryLoading: (appointmentId) =>
      set(state => produce(state, d => {
        d.data.historyCache[appointmentId] = null
      })),

    setHistory: (appointmentId, history) =>
      set(state => produce(state, d => {
        d.data.historyCache[appointmentId] = history
      })),

    setExpandedId: (expandedId) =>
      set(state => produce(state, d => { d.data.expandedId = expandedId })),

    setWaApptId: (waApptId) =>
      set(state => produce(state, d => { d.data.waApptId = waApptId })),

    setSettingsOpen: (open) =>
      set(state => produce(state, d => { d.data.settingsOpen = open })),

    setTemplate: (template) =>
      set(state => produce(state, d => { d.data.template = template })),
  },
}))
